export const cilMove = ["24 24","<path d='M18.929 7.739l-1.061 1.061 2.432 2.432h-7.531v-7.531l2.432 2.432 1.061-1.061-4.243-4.243-4.243 4.243 1.061 1.061 2.432-2.432v7.531h-7.569l2.432-2.432-1.061-1.061-4.243 4.243 4.243 4.243 1.061-1.061-2.432-2.432h7.569v7.569l-2.432-2.432-1.061 1.061 4.243 4.243 4.243-4.243-1.061-1.061-2.432 2.432v-7.569h7.531l-2.432 2.432 1.061 1.061 4.243-4.243-4.243-4.243z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-move.js
// module id = null
// module chunks = 